export const PrepaidDuty = 'PrepaidDuty';
export const SenderPrepay = 'SenderPrepay';
export const Recipient = 'Recipient';

export const BULK_ALERT_MODAL_PENDO = {
  prepayDutiesCheckbox: 'prepay-duty-bulk-alert-modal-prepay-duties-checkbox',
  automationCheckbox: 'prepay-duty-bulk-alert-modal-automation-checkbox',
  continueButton: 'prepay-duty-bulk-alert-modal-continue-button',
};
